// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3v1vc","title":"Header_title__rVU9H","left":"Header_left__1XYQb","clinicName":"Header_clinicName__3AG1n"};